export default {
    namespaced: true,
    state: {
        /**
         * This is an object constructed from the database that contains basic user details
         * and also their permissions. An example of what this looks like"
         *  {
                "UserProfile": {
                    "Email": "jtonkin@comunet.com.au",
                    "FirstName": "John",
                    "LastName": "Tonkin",
                    "Permissions": {
                        "access": true,
                        "admin": true,
                        "dailyhusbandry": true,
                        "newspecimen": true
                    }
                }
            }
         */
        user: null,
    },
    getters: {

    },
    mutations: {
        updateUser(state, value) {
            state.user = value;
        },
        removeUser(state) {
            state.user = null;
        }
    },
    actions: {
        
    }
  }